// extracted by mini-css-extract-plugin
export default {"statBlockContainer":"Tile_statBlockContainer__5Gn73","textBox":"Tile_textBox__caSuS","title":"Tile_title__Avy+5","data":"Tile_data__zs614"};